// Global Instructions Rule Applied!
//
// Deal Pipeline — tabbed page (owner 2026-08-27): the kanban board plus the
// Meeting Notes tab (meeting minutes / prep notes / investment themes from the
// pipeline meeting agent, design §8.E) and the Budget tab (owner 2026-11-03:
// the followed funds' capital and cash position against the committed deals).
// EmailCampaignsPage precedent: one
// app-shell tab, antd Tabs inside, panes kept mounted. The kanban component
// itself is unchanged — it renders exactly as it did when it WAS the page.
import React, { useState } from 'react'
import { Tabs } from 'antd'
import EarlyStageKanban from './kanbans/early_stage/index.tsx'
import PipelineMeetingsTab from '../../../pipeline_meetings/components/PipelineMeetingsTab.tsx'
import DealPipelineBudgetTab from './DealPipelineBudgetTab.tsx'

type TabKey = 'board' | 'meetings' | 'budget'

export default function DealPipelinePage() {
  const [activeTab, setActiveTab] = useState<TabKey>('board')

  return (
    <div className='h-full overflow-hidden bg-white'>
      <Tabs
        activeKey={activeTab}
        onChange={(k) => setActiveTab(k as TabKey)}
        destroyInactiveTabPane={false}
        className='h-full px-2 [&_.ant-tabs-content]:h-full [&_.ant-tabs-tabpane]:h-full [&_.ant-tabs-nav]:mb-0'
        items={[
          {
            key: 'board',
            label: 'Board',
            children: <EarlyStageKanban />
          },
          {
            key: 'meetings',
            label: 'Meeting Notes',
            children: <PipelineMeetingsTab />
          },
          {
            key: 'budget',
            label: 'Budget',
            children: <DealPipelineBudgetTab />
          }
        ]}
      />
    </div>
  )
}
